var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hl-wid ww3 adm-list" }, [
    _c(
      "ul",
      { staticClass: "tab-like" },
      [
        _c("li", { staticClass: "head" }, [
          _c("ul", [
            _c(
              "li",
              {
                staticClass: "title",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleSort("title")
                  }
                }
              },
              [
                _c("span", [_vm._v("Title")]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-inc",
                  class: { active: _vm.sort.title === true },
                  attrs: { href: "" }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-dec",
                  class: { active: _vm.sort.title === false },
                  attrs: { href: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "type",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleSort("type")
                  }
                }
              },
              [
                _c("span", [_vm._v("Type")]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-inc",
                  class: { active: _vm.sort.type === true },
                  attrs: { href: "" }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-dec",
                  class: { active: _vm.sort.type === false },
                  attrs: { href: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "language",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleSort("language")
                  }
                }
              },
              [
                _c("span", [_vm._v("Language")]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-inc",
                  class: { active: _vm.sort.language === true },
                  attrs: { href: "" }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-dec",
                  class: { active: _vm.sort.language === false },
                  attrs: { href: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "author",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleSort("author")
                  }
                }
              },
              [
                _c("span", [_vm._v("Author")]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-inc",
                  class: { active: _vm.sort.author === true },
                  attrs: { href: "" }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-dec",
                  class: { active: _vm.sort.author === false },
                  attrs: { href: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "date",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleSort("created")
                  }
                }
              },
              [
                _c("span", [_vm._v("Date")]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-inc",
                  class: { active: _vm.sort.created === true },
                  attrs: { href: "" }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-dec",
                  class: { active: _vm.sort.created === false },
                  attrs: { href: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "remove" })
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.items, function(item, ii) {
          return !item.parent
            ? [
                _c("li", [
                  _c(
                    "ul",
                    [
                      _c(
                        "li",
                        { staticClass: "title" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "content.postedit",
                                  params: { id: item.id }
                                }
                              }
                            },
                            [
                              item.subtitle
                                ? _c("em", [_vm._v(_vm._s(item.subtitle))])
                                : _vm._e(),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(item.title) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("li", { staticClass: "type" }, [
                        _vm._v(_vm._s(item.type ? item.type.title : "no type"))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "language" }, [
                        _vm._v(_vm._s(item.language))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "author" }, [
                        _vm._v(
                          _vm._s(
                            item.author
                              ? item.author.firstname +
                                  " " +
                                  item.author.lastname
                              : "no author"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "date" }, [
                        _vm._v(_vm._s(item.created))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "remove" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.remove(ii)
                              }
                            }
                          },
                          [_vm._v("remove")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("router-link", {
                        staticClass: "link-full",
                        attrs: {
                          to: {
                            name: "content.postedit",
                            params: { id: item.id }
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "file" }, [
                    item.password
                      ? _c("span", { staticClass: "file" }, [
                          _vm._v("Quiz password: " + _vm._s(item.password))
                        ])
                      : _c("span", { staticClass: "file" }, [
                          _vm._v(_vm._s(item.media && item.media.name))
                        ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.itemsForParent(item), function(item2, ii2) {
                  return _c("li", [
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "border-left": "2px solid #48c",
                          "padding-left": "18px"
                        }
                      },
                      [
                        _c(
                          "li",
                          { staticClass: "title" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "content.postedit",
                                    params: { id: item2.id }
                                  }
                                }
                              },
                              [
                                item2.parent.subtitle
                                  ? _c("em", [
                                      _vm._v(_vm._s(item2.parent.subtitle))
                                    ])
                                  : _vm._e(),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item2.title) +
                                    "\n                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", { staticClass: "type" }, [
                          _vm._v(
                            _vm._s(item2.type ? item2.type.title : "no type")
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "language" }, [
                          _vm._v(_vm._s(item2.language))
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              item2.author
                                ? item2.author.firstname +
                                    " " +
                                    item2.author.lastname
                                : "no author"
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "date" }, [
                          _vm._v(_vm._s(item2.created))
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "remove" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.remove(ii2)
                                }
                              }
                            },
                            [_vm._v("remove")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("router-link", {
                          staticClass: "link-full",
                          attrs: {
                            to: {
                              name: "content.postedit",
                              params: { id: item2.id }
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "file",
                        staticStyle: {
                          "border-left": "2px solid #48c",
                          "padding-left": "18px"
                        }
                      },
                      [
                        item2.password
                          ? _c("span", { staticClass: "file" }, [
                              _vm._v("Quiz password: " + _vm._s(item2.password))
                            ])
                          : _c("span", { staticClass: "file" }, [
                              _vm._v(_vm._s(item2.media && item2.media.name))
                            ])
                      ]
                    )
                  ])
                })
              ]
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }